import React from "react";

const FreeDelivery = () => {
  const benefits = [
    {
      title: "A Diverse Selection of Products",
      content: [
        "From everyday essentials to premium items, find everything you need in one place.",
      ],
      isList: false,
      icon: "bi-cart-check",
      iconColor: "text-success",
    },
    {
      title: "Affordable Shopping",
      content: ["Save on delivery charges while enjoying competitive prices."],
      isList: false,
      icon: "bi-cash-coin",
      iconColor: "text-warning",
    },
    {
      title: "Reliability",
      content: ["Trust us to handle your orders with care and precision."],
      isList: false,
      icon: "bi-check-circle",
      iconColor: "text-success",
    },
    {
      title: "Exclusive Deals",
      content: [
        "Enjoy special offers, discounts, and perks like free delivery on qualified orders.",
      ],
      isList: false,
      icon: "bi-gift",
      iconColor: "text-danger",
    },
  ];

  return (
    <section className="container container-lg py-5 px-40">
      <h2 className="text-center mb-4 text-3xl  fw-bold">
        Enjoy Free Delivery & Reliable Service
      </h2>
      <div className="flex-center w-100">
        <p className="text-center text-muted mb-5 col-lg-7 col-md-8 col-sm-12">
          Get free standard delivery when your order includes at least two
          items! At Lazmy, we believe in making your shopping experience
          seamless and rewarding.
        </p>
      </div>

      {benefits.map((benefit, index) => (
        <div key={index} className="my-20">
          <h3 className="text-xl mb-4 font-weight-bold">{benefit.title}</h3>
          {benefit.isList ? (
            <ul className="list-unstyled">
              {benefit.content.map((item, idx) => (
                <li
                  key={idx}
                  className="d-flex align-items-lg-center align-items-sm-start justify-content gap-4 mb-3"
                >
                  <i
                    className={`bi ${benefit.icon} ${benefit.iconColor} me-3`}
                    style={{ fontSize: "1.5rem" }}
                    aria-label={benefit.title}
                  ></i>
                  <div
                    className="text-muted mb-5"
                    dangerouslySetInnerHTML={{ __html: item }}
                  ></div>
                </li>
              ))}
            </ul>
          ) : (
            benefit.content.map((item, idx) => (
              <p
                key={idx}
                className="text-muted mb-5"
                dangerouslySetInnerHTML={{ __html: item }}
              ></p>
            ))
          )}
        </div>
      ))}
    </section>
  );
};

export default FreeDelivery;
